import { Component, OnDestroy } from '@angular/core';

import { OnInit } from '@angular/core';
import { utilities } from '../../../utils/utilities';


@Component({
    selector: 'nav-menu-xs',
    templateUrl: './navmenu-xs.component.html',
    styleUrls: ['./navmenu-xs.component.css']
})
export class NavMenuXSComponent implements OnInit, OnDestroy {

    public primaryHexCode: string = utilities.GetPrimaryColor();

    ngOnInit(): void { }

    ngOnDestroy() { }

}
